/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

export const partnersSectionStyles = {
  partnerSectionContainer: {
    backgroundColor: "#f4f4f4",
    textAlign: "center",
  },
  logoContainer: {
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: 180,
    maxHeight: 100,
    width: "100%",
    height: "auto",
  },
  logo: {
    maxWidth: "100%",
    maxHeight: 100,
  },
};
